import React from 'react';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import Config from "../../../config";
import {BlockDescription} from "elements/block-description/BlockDescription";

export const DEBUG_POPUP = 'DEBUG_POPUP';

export const Debug = ({currentCustomer, onOverlayClick}) => {
	return <DrawerPopup
		onOverlayClick={onOverlayClick}
	>
		<BlockDescription text={
			`Commit(test update): ${Config.getCommitHash()}\n
            UA: ${currentCustomer?.urbanAirshipChannelId}\n
            CustomerId: ${currentCustomer?.customerId}\n
            ServerUrl: ${Config.BaseServerUrl}\n
			`
		}/>
	</DrawerPopup>
}
